<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span="4">
                    <Input search v-model="formItem.sys_order_num" placeholder="输入订单号" @on-search="handleSearch" style="width:100%;" />
                </Col>
               
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span="8">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
                <Col span='4'>
                    <Select v-model="formItem.pay_status" placeholder="订单状态" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
        <Modal v-model="qrCodeModal" width="440">
            <img :src="qrCode" alt="">
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancel'>关闭</Button>
            </div>
        </Modal>
        <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
    
      
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
        setPay,
        setDel
      
    } from '@/api/schoolOrder'

    export default {
        name: 'user-components',
        data () {
            return {
                amount:'',
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    sys_order_num: '', 
                    start_time: '',
                    end_time: '',
                    pay_status: '',
                },
                qrCode:'',
                start_time: '',
                end_time: '',
                order_id:'',
                remindModal:false,
                qrCodeModal:false,
                remindContent:'',
                statusList:[
                    {id:0,name:'已支付'},
                    {id:1,name:'未支付'},
                ],
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                
                    {
                        title: '订单号',
                        align: 'center',
                        key: 'sys_order_num',

                    },
                   
                  
                    {
                        title: '下单时间',
                        align: 'center',
                        key: 'create_at',
                        width:150,
                    },
                    {
                        title: '支付时间',
                        align: 'center',
                        key: 'pay_at',
                        width: 150,
                    },
                    {
                        title: '订单金额',
                        align: 'center',
                        key: 'money',
                    },
                    {
                        title: '支付状态',
                        align: 'center',
                        key: 'pay_status',
                        render: (h, params) => {
                            if(params.row.pay_status==1){
                                return h('span', '已支付')
                            }else{
                                return h('span', '未支付')
                            }
                        }
                    },

                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 160,
                        render: (h, params) => {
                            if(params.row.pay_status==0){
                                return h('div', [
                                   
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.pay(params.row.id,params.row.money,params.row.name)
                                                
                                            }
                                        }
                                    }, '支付'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.id)
                                            }
                                        }
                                    }, '删除'),
                                  
                                ])
                            }else{
                                return h('div', '无操作')
                            }
                        }
                    }
                    
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                        this.amount=res.data.school_money;

                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            delete(id){
                this.order_id = id;
                this.remindContent = '确定删除该订单吗？';
                this.remindModal = true;
            },
            pay(id,money){
                this.order_id = id;
                this.remindContent = '确定支付该订单吗？ 扣除金额：'+money
              
                this.remindModal = true;
            },
            //提醒弹出层的确定事件
            primaryRemind(){
                if(this.remindContent == '确定删除该订单吗？'){
                    setDel({
                        id:this.order_id,
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                }else{
                    setPay({
                        order_id:this.order_id,
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                          
                            this.qrCode=res.data.wx_code_url;
                            this.qrCodeModal=true;
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                }
                    
                
            },

             // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
    
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 改变结束时间
            changEndtime(time) {
                if (time == '') {
                    this.formItem.end_time = '';
    
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 关闭提醒弹出
            cancelRemain(){
                this.remindModal = false; 
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.detailsModal=false;
                this.qrCodeModal=false;
            },
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
        }
    };
</script>
